export const RETROACTIVE_COMPENSATION_WIDGET_ID = 'retroactive'
